import React, {useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import { fetchHealthFacilitiesWithPackage, getClaims } from "../../action";
import "../../styles/theme.scss";
import {useTranslation} from "react-i18next";
import {Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import TableN from "../../reusableComponents/components/generics/TableN";
import CardHeading from "../CardHeading";
import Card from "../Card";
import { formatNumber } from "../../utils/helper";

function MedicalServicesTable() {
  const SignInSuccess = useSelector((state) => state);
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [medicalServicesData, setMedicalServicesData] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageInfo, setPageInfo] = useState();
  const [endCursors, setEndCursors] = useState();

  const [startCursors, setStartCursors] = useState();

  let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];


  const loadData = useCallback(() => {
    let params = buildQueryParams({
      filters: {},
      pageSize,
      beforeCursor: endCursors,
      afterCursor: startCursors,
    });
    if (SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]) {
      dispatch(fetchHealthFacilitiesWithPackage(healthData?.uuid, params));
    }
  }, [
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0],
    page,
    pageSize,
  ]);

  useEffect(() => {
    if (
      SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0]
    ) {
      loadData();
    }
  }, [
    SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0],
    page,
    pageSize,
  ]);

  const buildQueryParams = (state) => {
    let params = [];

    // Ensure state.filters exists before trying to access its properties
    if (state.filters) {
      params = Object.keys(state.filters)
        .filter((f) => !!state.filters[f]["filter"])
        .map((f) => state.filters[f]["filter"]);
    }

    if (!state.beforeCursor && !state.afterCursor) {
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.afterCursor) {
      params.push(`after: "${state.afterCursor}"`);
      params.push(`first: ${state.pageSize}`);
    }
    if (!!state.beforeCursor) {
      params.push(`before: "${state.beforeCursor}"`);
      params.push(`last: ${state.pageSize}`);
    }

    return params;
  };

  useEffect(() => {
    if (SignInSuccess?.fosaReducer?.healthFacilitiesPackageData) {
      setMedicalServicesData(
        SignInSuccess?.fosaReducer?.healthFacilitiesPackageData
      );
      setPageInfo(
        SignInSuccess?.fosaReducer?.healthFacilitiesPackageDataPageInfo
          .totalCount
      );
      setStartCursors(
        SignInSuccess?.fosaReducer?.healthFacilitiesPackageDataPageInfo
          ?.endCursor
      );
      setEndCursors(
        SignInSuccess?.fosaReducer?.healthFacilitiesPackageDataPageInfo
          ?.startCursor
      );
    }
  }, [SignInSuccess]);

  const headers = () => {
    var h = [
      "Code",
      "Nom",
      "Type",
      "Prix homologué",
      "Prix conventionné",
    ];

    return h;
  };

  const handleRowDoubleClick = (rowData) => {
    // navigate(`/fosa/claimForm/:id=${rowData.uuid}`);
  };

  const itemFormatters = () => {
    var row = [
      (item) => item?.actM2m?.fullCode || "",
      (item) => item?.actM2m?.label || "",
      (item) => item?.actM2m?.actType?.label || "",
      (item) =>
        item?.priceHomologated ? formatNumber(item.priceHomologated) : "",
      (item) => (item?.agreedPrice ? formatNumber(item.agreedPrice) : ""),
    ];

    return row;
  };

  const handleRowsPerPageChange = (newPageSize) => {
    setPageSize(newPageSize);
    setEndCursors(null);
    setStartCursors(null);
    setPage(0); // Reset to the first page when changing page size
  };

  const handleNavigation = (direction) => {
    if (direction === "forward") {
      setEndCursors(null);
    } else if (direction === "backward") {
      setStartCursors(null);
    }
  };

  return (
    <Grid container>
      {/* <TableN/> */}
      <Grid item xs={12}>
        <Card>
          <CardHeading
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography variant="h6">Tableau des actes</Typography>
            </Grid>
            <Grid item>
            </Grid>
          </CardHeading>

          <TableN
            headers={headers()}
            itemFormatters={itemFormatters()}
            items={medicalServicesData ? medicalServicesData : []}
            //withSelection={"single"}
            withPagination={true}
            rowsPerPageOptions={[10, 50, 100]}
            defaultPageSize={5}
            page={page}
            pageSize={pageSize}
            count={pageInfo}
            onChangePage={(event, newPage) => {
              setPage(newPage);
              handleNavigation(newPage > page ? "forward" : "backward");
            }}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onDoubleClick={handleRowDoubleClick}
            // rowLocked={this.rowLocked}
          />
        </Card>
      </Grid>
    </Grid>
  );
}

export default MedicalServicesTable;
